/* Nightpass - favoris : memorisation et bloc "Mes likes" dans le profil */
(function () {
  var KEY = 'np_favoris_handles';
  var PENDING = 'np_favoris_pending';

  function read() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Fiche produit : on suit le bouton coeur ---------- */
  function initHeart() {
    var btn = document.querySelector('[data-np-heart]');
    var handle = currentHandle();
    if (!btn || !handle || btn.dataset.favReady) return;
    btn.dataset.favReady = '1';

    var logged = btn.getAttribute('data-logged') === 'true';
    var loginUrl = btn.getAttribute('data-login-url') || '/account/login';

    function paint(on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    }

    /* Retour de connexion : on rejoue le like qui avait declenche la redirection,
       pour que le visiteur retrouve le produit deja en favori plutot que d'avoir
       a recliquer. */
    if (logged) {
      var pending = null;
      try { pending = window.localStorage.getItem(PENDING); } catch (e) {}
      if (pending && pending === handle) {
        var l0 = read();
        if (l0.indexOf(handle) === -1) { l0.push(handle); write(l0); }
        try { window.localStorage.removeItem(PENDING); } catch (e) {}
      }
    }

    paint(read().indexOf(handle) !== -1);

    btn.addEventListener('click', function () {
      /* Non connecte : on part directement vers la page de compte.

         La version precedente faisait clignoter le coeur en rouge puis tentait
         d'ouvrir la popup de connexion en cliquant l'icone compte du header.
         Deux ecrans possibles pour un meme geste, dont un qui n'existe pas sur
         toutes les pages : une seule destination vaut mieux.

         La boutique est en NOUVEAUX comptes clients : `routes.account_login_url`
         mene a la page hebergee par Shopify, qui sert a la fois a se connecter
         et a creer un compte. Il n'y a pas d'URL d'inscription separee a viser.

         L'intention est memorisee avant de partir : au retour, le produit est
         deja en favori. */
      if (!logged) {
        try { window.localStorage.setItem(PENDING, handle); } catch (e) {}
        window.location.href = loginUrl;
        return;
      }

      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
      write(list);
      paint(i === -1);
    });
  }

  /* ---------- Page compte : bloc en haut de l'onglet Profil ---------- */
  function initProfile() {
    var profile = document.getElementById('np-panel-profile');
    if (!profile || profile.dataset.favReady) return;
    profile.dataset.favReady = '1';

    var card = document.createElement('div');
    card.className = 'np-card';
    card.id = 'np-likes';
    profile.insertBefore(card, profile.firstChild);

    function render() {
      var handles = read();

      card.innerHTML =
        '<h2 class="np-card__title">Mes likes' +
          (handles.length ? ' <span class="np-likes__count">' + handles.length + '</span>' : '') +
        '</h2>';

      if (!handles.length) {
        card.insertAdjacentHTML('beforeend',
          '<p class="np-note">Aucun article en favori pour le moment. Touchez le cœur sur une fiche produit pour l\'ajouter ici.</p>' +
          '<a class="np-btn np-btn--ghost np-btn--sm" href="/collections/all" style="margin-top: 1.6rem;">Parcourir le catalogue</a>');
        return;
      }

      card.insertAdjacentHTML('beforeend', '<div class="np-favs" data-np-favs></div>');
      var grid = card.querySelector('[data-np-favs]');

      handles.forEach(function (handle) {
        fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
          .then(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var item = document.createElement('article');
            item.className = 'np-fav';
            item.innerHTML =
              '<a class="np-fav__media" href="/products/' + handle + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              '</a>' +
              '<div class="np-fav__body">' +
                '<a class="np-fav__title" href="/products/' + handle + '">' + p.title + '</a>' +
                '<p class="np-fav__price">' + money(p.price) + '</p>' +
                (p.available ? '' : '<p class="np-fav__out">Momentanément indisponible</p>') +
              '</div>' +
              '<button type="button" class="np-fav__x" aria-label="Retirer des favoris">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
              '</button>';

            item.querySelector('.np-fav__x').addEventListener('click', function () {
              var list = read();
              var i = list.indexOf(handle);
              if (i !== -1) { list.splice(i, 1); write(list); }
              render();
            });

            grid.appendChild(item);
          })
          .catch(function () {
            /* Produit supprime ou renomme : on nettoie la liste */
            var list = read();
            var i = list.indexOf(handle);
            if (i !== -1) { list.splice(i, 1); write(list); }
          });
      });
    }

    render();
  }

  function init() { initHeart(); initProfile(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
